import React, { useMemo } from "react";
import { useDataWithRoute } from "../utils/hooks";
import { VsiBubble } from "../styled/App.styled";
import FlexChart from "../components/FlexChart";
import { formatDualAxisStockChartConfig } from "../utils/Helpers";
import { Spinner } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";

export default function HostLunPerformanceDetail({ params }) {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("HOSTS");

  const route = useMemo(() => `/api/v6/report/host_lun_performance_detail_proc?client_id=${clientId}&period_id=${periodId}&device_name=${params[0].value}&host_name=${params[1].value}`, [clientId, periodId, params]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  const { chartSeries, chartCategories } = useMemo(() => {
    const allSeriesData = formatDualAxisStockChartConfig(recordset || [], [
      {
        type: "column",
        name: "Read IO",
        field: "read_io",
        yAxis: 0
        // zoneAxis: 'x',
      },
      {
        type: "column",
        name: "Write IO",
        field: "write_io",
        yAxis: 0
        // zoneAxis: 'x',
      },
      {
        type: "spline",
        name: "Latency (ms)",
        field: "latency",
        yAxis: 1
        // dashStyle: 'dash',
        // disableMarker: true,
      }
    ], 'lun_name');

    return {
      chartSeries: allSeriesData.series,
      chartCategories: allSeriesData.categories,
    }
  }, [recordset]);

  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubble>
      <FlexChart series={chartSeries}
                 constructorType={"chart"}
                 disableRangeSelector={true}
                 navDisabled={true}
                 height={420}
                 config={{
                   colors: ["#1E90FF", "#000069", "#228B22"],
                   yAxis: [
                     {
                       title: {
                         text: "IOPS"
                       },
                       opposite: false
                     },
                     {
                       title: {
                         text: "Latency (ms)"
                       },
                       opposite: true
                     }
                   ]
                 }}
                 categories={chartCategories} />
    </VsiBubble>
  );
}
